//import React, { Component } from 'react';

import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
//import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function Information() {
    // const { reCreate } = useContext(UserContext);
    const { state } = useLocation();
    let navigate = useNavigate();
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            Username: "",
            Password: "",
            Name: "",
            Mobile: "",
            SimNumber: "",
            CarName: "",
            icon: "",
            ModeDevice: "0",
        });

    useEffect(() => {
        if (!state || !state.form) {
            toast.error('داده ها ناقص است', { theme: "colored" });
            navigate('/login');
            return;
        }
        setForm({ ...form, Username: state.form.Username, Password: state.form.Password });
    }, []);



    const handlePosting = async (e) => {
        e.preventDefault();
        if (form.Name.trim().length <= 0) {
            toast.error('نام مشخص نشده است', { theme: "colored" });
            return
        }
        if (form.Mobile.trim().length <= 0) {
            toast.error('شماره موبایل مشخص نشده است', { theme: "colored" });
            return
        }
        if (form.SimNumber.trim().length <= 0) {
            toast.error('شماره سیم کارت دستگاه مشخص نشده است', { theme: "colored" });
            return
        }
        if (form.CarName.trim().length <= 0) {
            toast.error('نام دستگاه مشخص نشده است', { theme: "colored" });
            return
        }
        setIsPosting(true);
        await noronServices.NewDeviceUser(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                http.setLocalJwt(data.payload.token.access_token);
                http.setLocalJwtRefresh(data.payload.token.refresh_token);
                navigate('/main', { replace: true })
            })
            .catch(err => {
                setIsPosting(false);
            });
    }
    const logout = (e) => {
        e.preventDefault();
        e.stopPropagation();
        http.logout();
        http.goLogin();
    }

    return (
        <>
            <div className="container col-xl-10 col-xxl-8 px-4 py-5">
                <div className="row align-items-center g-lg-5 py-5">

                    <div className="col-md-10 mx-auto col-lg-5">
                        <form asp-action="Information" className="p-4 p-md-5 border rounded-3 bg-light" method="post">
                            <div className="form-floating mb-3">
                                <input asp-for="Name"
                                    type="text"
                                    name="Name"
                                    value={form.Name}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="نام و نام خانوادگی" autoComplete="off" />
                                <label asp-for="Name">نام و نام خانوادگی</label>
                                <span asp-validation-for="Name" className="text-danger"></span>
                            </div>
                            <div className="form-floating mb-3">
                                <input asp-for="Password"
                                    type="number"
                                    name="Mobile"
                                    value={form.Mobile}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control" placeholder="شماره همراه مالک" autoComplete="off" />
                                <label asp-for="Mobile">شماره همراه مالک</label>
                                <span asp-validation-for="Mobile" className="text-danger"></span>
                                <div className="alert alert-danger" role="alert">از این پس برای ورود از شماره همراه خود به عنوان نام کاربری استفاده فرمایید</div>
                            </div>
                            <div className="form-floating mb-3">
                                <input asp-for="SimNumber"
                                    type="number"
                                    name="SimNumber"
                                    value={form.SimNumber}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control" placeholder="شماره سیم کارت درون ردیاب" autoComplete="off" />
                                <label asp-for="SimNumber">شماره سیم کارت درون ردیاب</label>
                                <span asp-validation-for="SimNumber" className="text-danger"></span>
                            </div>

                            <div className="form-floating mb-3">
                                <input asp-for="SimNumber"
                                    type="text"
                                    name="CarName"
                                    value={form.CarName}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control" placeholder="نام خودرو" autoComplete="off" />
                                <label asp-for="CarName">نام خودرو</label>
                                <span asp-validation-for="CarName" className="text-danger"></span>
                            </div>

                            <div className="form-floating mb-3">
                                <Dropdown drop="down"
                                    onSelect={eventKey => {
                                        //console.log('eventKey', eventKey);
                                        setForm({
                                            ...form, icon: eventKey
                                        });
                                    }}
                                >
                                    <Dropdown.Toggle className="form-control" id="dropdown-custom-components">
                                        {form.icon != "" &&
                                            <img src={`/images/${form.icon}`} className="navbarIcon" />}تصویر خودرو
                                        {form.icon == "" && <>
                                            <img src="/images/car1.png" className="navbarIcon" /></>}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="form-control dropdownMenuCustom">
                                        {Array(24).fill().map((item, i) => (
                                            <Dropdown.Item key={"drop" + i + 1} eventKey={`car${i + 1}.png`}>
                                                <img src={`/images/car${i + 1}.png`} className="dropDownImageItem" />
                                            </Dropdown.Item>))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                            <div className="form-floating mb-3">
                                <select asp-for="SimNumber"
                                    name="ModeDevice"
                                    value={form.ModeDevice}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-select" placeholder="نوع ردیاب" autoComplete="off" >
                                    <option value="0">S300</option>
                                    <option value="3">S350</option>
                                    <option value="1">S400</option>
                                    <option value="2">S500</option>
                                    <option value="4">S600</option>
                                </select>
                                <label asp-for="ModeDevice">نوع ردیاب</label>
                                <span asp-validation-for="ModeDevice" className="text-danger"></span>
                            </div>

                            <button className="w-100 btn btn-lg btn-primary"
                                onClick={handlePosting}
                                disabled={isPosting}>
                                ثبت
                                {isPosting &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                            </button>
                            <hr className="my-4" />

                            <Link to="/" onClick={logout}>ورود با شماره متفاوت</Link>

                        </form>
                    </div>
                </div>
            </div>
        </>

    );

}
